import axios from 'axios';

// Общий контент нужен сразу нескольким компонентам на каждой странице
// (шапка, бургер-меню, подвал, блоки About) - запрос делаем один раз и делимся им
let aboutPromise = null;

export default class AboutService {
    // Тексты блока ABOUT US на главной, страницы About, офисы и соцсети
    static getAbout() {
        if (!aboutPromise) {
            aboutPromise = axios.get('/api/v1/about/')
                .catch((error) => {
                    // Не кешируем неудачу, чтобы следующий вызов повторил запрос
                    aboutPromise = null;
                    throw error;
                });
        }
        return aboutPromise;
    }
}
